import { PatientSkillAcqActiveTargetListActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  loadingCollectedData: false,
  loadingPreviousTrial: false,
  loadingTaskAnalysis: false,
  patientSkillAcqActiveTargetList: null,
  saved_PatientSkillsAcquisitionCollectedData: null,
  patientSkillAcqPreviousTrialList: null,
  patientSkillAcqCollectedDataList: null,
  deleted_patientSkillAcqCollectedData: null,
  patientSkillAcqTaskAnalysisList: null,
  deleted_patientSkillAcqPrevTrial: null,
  selectedProgramForTarget: null,
  selectedProgramForTargetDropdownSkillAcq: null,
  patientSkillAcqActiveTargetListNewFlow: null,
  saved_PatientSkillsAcquisitionCollectedFrequencyData: null,
  saved_PatientSkillsAcquisitionCollectedDurationData: null,
  isRecordDurationRenderTrueSkAq: true,
  isStartSkAq: [],
  isSaveSkAq: [],
  secondsElapsedSkAq: [],
  incrementerSkAq: [],
  newIncrementerSkAq: [],
  patientSkillAcqCollectData: [],
  patientSkillAcqCollectDataReset: [],
  masterData: [],
  patientSkillTarget: [],
  patientSkillProgram: [],
  patientSkillDomain: [],
  todaysCollectedData: null,
  collapseMenuId:null,
  isEventOccurePatientSkillAcqCollectDataNewFlow:false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetList.REQUEST:
      return {
        ...state,
        loading: true,
        patientSkillAcqActiveTargetList: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientSkillAcqActiveTargetList: payload
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetListNewFlow.REQUEST:
      return {
        ...state,
        loading: true,
        patientSkillAcqActiveTargetListNewFlow: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetListNewFlow.SUCCESS:
      return {
        ...state,
        loading: false,
        patientSkillAcqActiveTargetListNewFlow: payload
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.REQUEST:
      return {
        ...state,
        loadingPreviousTrial: true,
        loading: true,
        patientSkillAcqPreviousTrialList: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS:
      return {
        ...state,
        loadingPreviousTrial: false,
        loading: false,
        patientSkillAcqPreviousTrialList: payload
      };
    case PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectData.REQUEST:
      return {
        ...state,
        loading: true,
        loadingCollectedData: true,
        saved_PatientSkillsAcquisitionCollectedData: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectData.SUCCESS:
      return {
        ...state,
        loading: false,
        loadingCollectedData: false,
        saved_PatientSkillsAcquisitionCollectedData: payload,
      };

    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectedDataList.REQUEST:
      return {
        ...state,
        loading: true,
        patientSkillAcqCollectedDataList: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectedDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientSkillAcqCollectedDataList: payload
      };

    case PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientSkillAcqCollectedData: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientSkillAcqCollectedData: payload
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTaskAnalysisList.REQUEST:
      return {
        ...state,
        loadingTaskAnalysis: true,
        patientSkillAcqTaskAnalysisList: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTaskAnalysisList.SUCCESS:
      return {
        ...state,
        loadingTaskAnalysis: false,
        patientSkillAcqTaskAnalysisList: payload
      };
    case PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientSkillAcqPrevTrial: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientSkillAcqPrevTrial: payload
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqSelectedProgramForTarget.REQUEST:
      return {
        ...state,
        loading: true,
        selectedProgramForTarget: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqSelectedProgramForTarget.SUCCESS:
      return {
        ...state,
        loading: false,
        selectedProgramForTarget: payload
      };
    case PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectFrequencyData.REQUEST:
      return {
        ...state,
        loading: true,
        loadingCollectedData: true,
        saved_PatientSkillsAcquisitionCollectedFrequencyData: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectFrequencyData.SUCCESS:
      return {
        ...state,
        loading: false,
        loadingCollectedData: false,
        saved_PatientSkillsAcquisitionCollectedFrequencyData: payload,
      };
    case PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectDurationData.REQUEST:
      return {
        ...state,
        loading: true,
        loadingCollectedData: true,
        saved_PatientSkillsAcquisitionCollectedDurationData: null,
      };
    case PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectDurationData.SUCCESS:
      return {
        ...state,
        loading: false,
        loadingCollectedData: false,
        saved_PatientSkillsAcquisitionCollectedDurationData: payload,
      };
    case PatientSkillAcqActiveTargetListActionTypes.set_isRecordDurationRenderTrueSkAq.SUCCESS:
        return {
            ...state,
            loading: false,
            isRecordDurationRenderTrueSkAq: payload,
        };

    case PatientSkillAcqActiveTargetListActionTypes.start_recordDurationTimerSkAq.SUCCESS:
        return {
            ...state,
            loading: false,
            isStartSkAq: payload
        }
    case PatientSkillAcqActiveTargetListActionTypes.start_secondsElapsedSkAq.SUCCESS:
        return {
            ...state,
            loading: false,
            secondsElapsedSkAq: payload
        }   
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqDomainPatientId.REQUEST:
      return {
          ...state,
          loading: false,
          patientSkillDomain: []
      }   
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqProgramDomainIdPatientId.REQUEST:
        return {
            ...state,
            loading: false,
            patientSkillProgram: [],
        }   
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTargetPatientId.REQUEST:
        return {
            ...state,
            loading: false,
            patientSkillTarget: [],
        } 
    case PatientSkillAcqActiveTargetListActionTypes.get_master_data.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: [],
      };  
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlow.REQUEST:
      return {
        ...state,
        loading: true,
        patientSkillAcqCollectData: [],
      };  
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqDomainPatientId.SUCCESS:
        return {
            ...state,
            loading: false,
            patientSkillDomain: payload
        }
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqProgramDomainIdPatientId.SUCCESS:
        return {
            ...state,
            loading: false,
            patientSkillProgram: payload
        }   
    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTargetPatientId.SUCCESS:
        return {
            ...state,
            loading: false,
            patientSkillTarget: payload
        } 
        case PatientSkillAcqActiveTargetListActionTypes.get_master_data.SUCCESS:
          return {
            ...state,
            loading: false,
            masterData: payload,
          };  
        case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlow.SUCCESS:
          return {
            ...state,
            loading: false,
            isEventOccurePatientSkillAcqCollectDataNewFlow:true,
            patientSkillAcqCollectData: payload,
          };  
          case PatientSkillAcqActiveTargetListActionTypes.get_skillAcqCollectedDataById.REQUEST:
            return {
              ...state,
              loading: true,
              todaysCollectedData: null,
            };
          case PatientSkillAcqActiveTargetListActionTypes.get_skillAcqCollectedDataById.SUCCESS:
            return {
              ...state,
              loading: false,
              todaysCollectedData: payload,
            }; 
    case PatientSkillAcqActiveTargetListActionTypes.enable_todaysdata.SUCCESS:
      return {
          ...state,
          displayTodaysData: true,
      }   
    case PatientSkillAcqActiveTargetListActionTypes.desable_todaysdata.SUCCESS:
        return {
          ...state,
          displayTodaysData: false,
        }  

    case PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlowReset.SUCCESS:
      return {
        ...state,
        patientSkillAcqCollectData: []
      }
    
      case PatientSkillAcqActiveTargetListActionTypes.setIsEventOccurePatientSkillAcqCollectDataNewFlowFalse.SUCCESS:
        return{
          ...state,
          isEventOccurePatientSkillAcqCollectDataNewFlow:false
        }
    case PatientSkillAcqActiveTargetListActionTypes.setCollapseMenuId.SUCCESS:
      // console.log("setcollapseMenuId inside reducer", payload)  
      return{
          ...state,
          collapseMenuId:payload
        }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/reducers/targetsReducer.js